import { IoIosArrowBack } from "react-icons/io";
import { GiDatabase } from "react-icons/gi";
import { FaStopwatch } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import DeliverToggle, { ColorToggle, ProductDeliverToggle } from "../../../components/toggleButton/DeliverToggle";
import "../../../styles/stores/stockManagement/addProductForm.css";
import { Package, Tag, Grid3X3, Info, Ruler, Hash, DollarSign, TrendingUp, RulerDimensionLine, Palette, Globe } from "lucide-react";

import { FiPlus } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
import { uploadProductImageUrl, createProductUrl, addProductToWarehouseUrl } from "../../../api/endpoints";
import { useParams } from "react-router-dom";
import { setWarehouse } from "../../../slice/warehouseSlice";
import Wishes from "./SelectSize";
import WisheColor from "./ColorWish";
import Spinner from "../../../components/uxCollections/Loaders";
import ImageCropper from "../../../components/imageCropper/ImageCropper";
import UploadImageWithPhone from "./UploadImageWithPhone/UploadImageWithPhone";
import { getAllData, saveData } from "../../../tools/indexdb";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // 💅 includes default UI styling
import { BsArrowBarLeft, BsPhone, BsUpcScan, BsUpload } from "react-icons/bs";

import JsBarcode from "jsbarcode";
import { setUser } from "../../../slice/webStoreUserSlice";
import BarcodeScanner from "../makeTansaction/barCodeScanner/BarCodeScanner";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

let imagePlaceholder = "https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png";

export const listOfProductCategory = [
  "Agriculture",
  "Automotive",
  "Baby Products",
  "Beauty & Personal Care",
  "Books & Stationery",
  "Building Materials",
  "Cameras & Photography",
  "Computers & Laptops",
  "Mobile Phones & Accessories",
  "Monitors & TV",
  "Office Supplies",
  "Outdoor & Garden",
  "Pet Supplies",
  "E-Cigarettes & Vaping",
  "Smoking Accessories",
  "Decorations",
  "DIY & Tools",
  "Drinks & Water",
  "Electronics",
  "Fashion",
  "Printers",
  "Fitness & Gym Equipment",
  "Food & Beverages",
  "Furniture",
  "Gaming",
  "Grocery",
  "Health and Beauty",
  "Home and Office",
  "Home Appliances",
  "Jewelleries",
  "Kitchen Appliances",
  "Kitchen Utensils",
  "Lightnings & Wiring",
  "Luggage & Bags",
  "Medical Supplies",
  "Mobile Phones",
  "Motor Spare Parts",
  "Music Instruments",
  "Outdoor & Garden",
  "Paints & Brush",
  "PC & Desktops",
  "Pet Supplies",
  "Phone Accessories",
  "Phones and Tablets",
  "Security & Surveillance",
  "Sex Toys",
  "Shoes & Footwear",
  "Smart Home Devices",
  "Software",
  "Sporting Goods",
  "Toys and Games",
  "Watches",
].sort();

export const productUnit = [
  "Pieces",
  "Cartons",
  "Bundles",
  "Packs",
  "Dozens",
  "Gross",
  "Sets",
  "Pairs",
  "Boxes",
  "Units",
  "Kits",
  "Meters",
  "Liters",
  "Grams",
  "Kilograms",
  "Bags",
  "Packets",
  "Tons",
  "Barrels",
  "Cans",
  "Crates",
  "Drums",
  "Jars",
  "Cartons",
  "Pallets",
  "Reams",
  "Rolls",
  "Trays",
  "Vials",
  "Sheets",
  "Yards",
].sort();

export const SizeTag = ({ size }) => {
  return (
    <>
      <div className='sizeTag12'>
        <p>{size}</p>
      </div>
    </>
  );
};

export const ColorTag = ({ color }) => {
  return (
    <>
      <div className='ColorTag12'>
        <p style={{ backgroundColor: `${color}` }}></p>
      </div>
    </>
  );
};
export const generateNumericId = (length = 18) => {
  const digits = "0123456789";
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(bytes, (b) => digits[b % 10]).join("");
};

const unWantedInputs = ["+", "-", "e", "E", "."];
export const AddStockPage = ({ changePage, warehouse, setAlertDisplay, socket, productLists = [] }) => {
  const [isStockLimitLessThanQuantity, setIsStockLimitLessThanQuantity] = useState(true);
  const [isCostPricelessThanUnitPrice, setIsCostPricelessThanUnitPrice] = useState(true);
  const [selectedSize, setSelectedSize] = useState(null);
  const [size, setSize] = useState(false);
  const [openSizeModal, setOpenSizeModal] = useState(false);
  const [isColorApplicable, setIsColorApplicable] = useState(false);
  const [openColorModal, setOpenColorModal] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [canDeliver, setCanDeliver] = useState(false);
  const [openScannerWindow, setOpenScannerWindow] = useState(false);
  const [scannedID, setScannedID] = useState(null);
  const [productData, setProductData] = useState({
    name: "",
    brand: "",
    productCategory: "",
    productState: "",
    unit: "",
    quantity: "",
    stockLimit: "",
    costPrice: "",
    unitPrice: "",
    productDescription: "",
    deliveryTime: canDeliver ? 0 : null,
    deliveryFee: canDeliver ? 0 : null,
  });
  const [productImages, setProductImages] = useState([]);
  const [productImageStage, setProductImageStage] = useState(null);
  const [productBuffer, setProductBuffer] = useState([]);
  const [productBufferStage, setProductBufferStage] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [takeImageWithPhone, setTakeImageWithPhone] = useState(false);
  const [isImageCropperOpen, setIsImageCropperOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);
  const { store } = useSelector((state) => state.store);
  const { wareHouseID } = useParams();
  const dispatch = useDispatch();

  const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

  let endpoint = warehouse ? addProductToWarehouseUrl + wareHouseID : createProductUrl + store._id;

  let missingInputs = [];
  let imagePlaceholder = ["https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png"];

  useEffect(() => {
    // check if product buffer is empty
    /*   if (productBuffer.length === 0) {
      missingInputs.push("Product image");
    } else {
      missingInputs = missingInputs.filter((item) => item !== "Product image");
    } */

    console.log("checking form validity", productData.deliveryFee === null, productData.deliveryTime);

    /* updating missing input */
    Object.entries(productData).forEach(([key, value]) => {
      if (value === "" || value === NaN || value === "<p><br></p>") {
        console.log(key, value);
        // setIsFormValid(false);
        if (key !== "productDescription" && key !== "deliveryTime" && key !== "deliveryFee") {
          missingInputs.push(key);
        }
      } else {
        missingInputs = missingInputs.filter((item) => item !== key);
      }
    });
    setMissingFields(missingInputs);

    if (canDeliver && missingFields.length === 0 /* && productBuffer.length > 0 */) {
      setIsFormValid(true);
    } else if (!canDeliver && missingFields.length === 2 /* && productBuffer.length > 0 */) {
      // filter out delivery time and delivery fee
      /*  let filteredMissingFields = missingFields.filter((field) => field !== "deliveryTime" && field !== "deliveryFee");
      console.log(filteredMissingFields, isFormValid, "filteredMissingFields");
      setMissingFields(filteredMissingFields);
      setIsFormValid(true); */
      // console.log(filteredMissingFields, isFormValid, "filteredMissingFields");
    } else {
      console.log("not valid");
      setIsFormValid(false);
    }

    //
  }, [productData, productBuffer, canDeliver]);

  useEffect(() => {
    if (size) {
      setOpenSizeModal(true);
    } else {
      setOpenSizeModal(false);
      setSelectedSize(null);
    }
  }, [size]);
  useEffect(() => {
    /* check if color is applicable */
    if (isColorApplicable) {
      setOpenColorModal(true);
    } else {
      setOpenColorModal(false);
      setSelectedColor(null);
    }
  }, [isColorApplicable]);

  useEffect(() => {
    console.log(missingFields);
    if (canDeliver && missingFields.length === 0 /* && productBuffer.length > 0 */) {
      setIsFormValid(true);
    } else if (!canDeliver && missingFields.length === 0 /* && productBuffer.length > 0 */) {
      setIsFormValid(true);
    } else {
      console.log("not valid");
      setIsFormValid(false);
    }
  }, [missingFields]);

  useEffect(() => {
    console.log(productData.quantity, productData.stockLimit);
    console.log(parseInt(productData.stockLimit) >= parseInt(productData.quantity));
    if (productData.quantity && productData.stockLimit && parseInt(productData.stockLimit) >= parseInt(productData.quantity)) {
      setIsStockLimitLessThanQuantity(false);
    } else {
      setIsStockLimitLessThanQuantity(true);
    }
  }, [productData.quantity, productData.stockLimit]);

  useEffect(() => {
    if (productData.unitPrice && productData.costPrice && parseInt(productData.costPrice) >= parseInt(productData.unitPrice)) {
      setIsCostPricelessThanUnitPrice(false);
    } else {
      setIsCostPricelessThanUnitPrice(true);
    }
  }, [productData.unitPrice, productData.costPrice]);

  const barcodeRef = useRef(null);
  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, scannedID, {
        format: "CODE128",
        displayValue: true,
        width: 2,
        height: 30,
        margin: 0,
        fontSize: 10,
      });
    }
  }, [scannedID]);

  const handleProductImageUpload = (e) => {
    let image = e.target.files[0];
    setProductBufferStage([...productBuffer, image]); /* irreleveant */
    console.log(productImages);
    if (image) {
      let reader = new FileReader();
      reader.onload = function (evt) {
        /* setProductImages([...productImages, evt.target.result]); */
        setProductImageStage(evt.target.result);
        setIsImageCropperOpen(true);
        setIsImageUploaded(true);
      };
      reader.readAsDataURL(image);
    } else {
      uiAlert("upload failed", "error");
    }
  };
  // productBuffer is an instance of blob
  const uploadImages = async () => {
    // incase upload failed
    let accessToken = localStorage.getItem("accessToken");
    let formData = new FormData();
    productBuffer.forEach((image) => {
      formData.append("ProductImage", image);
    });
    console.log(formData, "formData");

    try {
      let resp1 = await fetch(uploadProductImageUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });
      if (resp1.ok) {
        console.log("uploaded");
        let { imageUrl } = await resp1.json();
        console.log(imageUrl, "imageUrl");
        setIsImageUploaded(true);

        return imageUrl;
      } else {
        uiAlert("Image upload failed", "error");
        return imagePlaceholder;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createProduct = async () => {
    // check if missing inputs is filled
    if (missingInputs.length > 0) {
      uiAlert("Please fill all the fields" + " " + missingInputs.join(", "), "warning");
      return;
    }
    if (!isFormValid) {
      uiAlert("Please fill all the fields" + " " + missingFields.join(", "), "warning");

      return;
    }
    if (!isStockLimitLessThanQuantity) {
      uiAlert("Stock limit must be less than quantity", "warning");
      return;
    }

    //check if a product with the same name and brand already exists in the store

    if (Array.isArray(productLists) && productLists.length > 0) {
      const existingProduct = productLists.find(
        (product) => product.name?.toLowerCase() === productData.name?.toLowerCase() && product.brand?.toLowerCase() === productData.brand?.toLowerCase()
      );

      if (existingProduct) {
        const shouldContinue = window.confirm(
          `A product with the same name and brand already exists in your ${
            warehouse ? " warehouse" : "store"
          }. Do you want to continue, or restock the existing product instead?`
        );

        if (!shouldContinue) return;
      }
    }

    setIsLoading(true);

    let imageUrl = isImageUploaded ? await uploadImages() : imagePlaceholder; // if image is not uploaded, use placeholder image

    let accessToken = localStorage.getItem("accessToken");

    let product = {
      name: productData.name,
      brand: productData.brand,
      productCategory: productData.productCategory,
      productState: productData.productState,
      unit: productData.unit,
      quantity: parseInt(productData.quantity),
      stockLimit: parseInt(productData.stockLimit),
      costPrice: parseInt(productData.costPrice),
      unitPrice: parseInt(productData.unitPrice),
      productDescription: productData.productDescription,
      canBeDelivered: canDeliver,
      deliveryTime: canDeliver && productData.deliveryTime === null ? 4 : Number(productData.deliveryTime),
      deliveryFee: canDeliver && productData.deliveryFee === null ? 0 : Number(productData.deliveryFee),
      imageUrl: imageUrl,
      sizeApplicability: size,
      selectedSizes: selectedSize ? selectedSize.map((size) => size.code) : null,
      colorApplicability: isColorApplicable,
      selectedColors: selectedColor ? selectedColor.map((color) => color.name) : null,
      createdInStore: warehouse ? false : true,
      createdInWarehouse: warehouse ? true : false,
      scannedID: scannedID ? scannedID : generateNumericId(),
    };

    try {
      console.log(endpoint);
      let resp2 = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(product),
      });
      if (resp2.ok) {
        if (warehouse) {
          let updatedWarehouse = await resp2.json();
          warehouse && dispatch(setWarehouse(updatedWarehouse));
          warehouse && changePage("warehouseStock");
        } else {
          let { newProduct, user } = await resp2.json();
          /*  let { storeCollections, user } = await resp2.json(); */

          /* update IndexDb with created product */
          let storeData = await getAllData(store.storeName);
          if (storeData) {
            storeData.storeProductCollection.push(newProduct);

            await saveData(store.storeName, storeData);
            dispatch(setUser(user));
            changePage("stockManagement");
          }
        }

        setIsLoading(false);
        setAlertDisplay({
          showAlert: true,
          type: "success",
          title: "Product created successfully",
          message: ` You have successfully added a product to your ${warehouse ? "warehouse" : "store"}`,
        });
      } else {
        // uiAlert("product creation failed");
        setAlertDisplay({
          showAlert: true,
          type: "error",
          title: "Product creation failed",
          message: "Please try again later",
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTyping = (value) => {
    setProductData({ ...productData, productDescription: value });
    setIsTyping(true);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Reset isTyping to false after 1 second of no input
    const timeout = setTimeout(() => {
      setIsTyping(false);
    }, 1000);

    setTypingTimeout(timeout);
  };
  const setOpenScanner = () => {
    setOpenScannerWindow(true);
  };
  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className='AddSto74y5Pa'>
        <div
          onClick={() => {
            warehouse ? changePage("warehouseStock") : changePage("stockManagement");
          }}
          className='adStockBackBut'
        >
          <BsArrowBarLeft size={20} />
          <p>back</p>
        </div>
        <div className='addStockWrapper'>
          <div>
            {/*  <p className='DivTitleCrp'>Create product</p> */}
            <div className='multipleProdDIv'>
              <div className='singleProdcDIv'>
                {" "}
                <img src={!productImages.length == 0 ? productImages[0] : imagePlaceholder} />
              </div>
              <div className='singleProdcDIv'>
                <img src={productImages.length > 1 ? productImages[1] : imagePlaceholder} />
              </div>
              <div className='singleProdcDIv'>
                {" "}
                <img src={productImages.length > 2 ? productImages[2] : imagePlaceholder} />
              </div>
              <div className='singleProdcDIv'>
                {" "}
                <img src={productImages.length > 3 ? productImages[3] : imagePlaceholder} />
              </div>
            </div>
            <div className='stockContentDivBor'>
              <div className='CPimage'>
                <div>
                  <div className='cpImageMaindisp'>
                    <img src={!productImages.length == 0 ? productImages[0] : imagePlaceholder} />
                  </div>
                  <p>You can upload upto 4 images</p>
                </div>
                <div className='uploamainImagButdiv'>
                  {!isMobileDevice && (
                    <button onClick={() => productImages.length < 4 && setTakeImageWithPhone(true)} className='uploadImageWithPhoneButton'>
                      <BsPhone size={16} />
                      Snap with phone
                    </button>
                  )}
                  <label className='uploadMainImageBut'>
                    <BsUpload size={16} />
                    Upload image{" "}
                    {productImages.length < 4 && (
                      <input className='uploadStoreImageIn3' onChange={(e) => handleProductImageUpload(e)} type={"file"} accept='image/*' />
                    )}{" "}
                  </label>

                  <p
                    onClick={() => {
                      setProductImages([]);
                      setIsImageUploaded(false);
                      setProductBuffer([]);
                    }}
                  >
                    Remove
                  </p>
                </div>
              </div>
              {/* testing form */}
              {/* <div style={{ marginBottom: "40px" }} className='inputCustdet'>
                <input
                  maxLength={30}
                  value={productData.name}
                  onChange={(e) => setProductData({ ...productData, name: e.target.value })}
                  type={"text"}
                  required={true}
                />
                <p className='placeholderInputcusd'>Product name</p>
              </div> */}
              <div className='mpf-form'>
                {/* Product Name */}
                <div className='mpf-group'>
                  <label htmlFor='mpf-product-name-input' className='mpf-label'>
                    <Package size={18} className='mpf-icon' />
                    Product name
                  </label>
                  <input
                    maxLength={90}
                    value={productData.name}
                    onChange={(e) => setProductData({ ...productData, name: e.target.value })}
                    type='text'
                    id='mpf-product-name-input'
                    name='productName'
                    placeholder='Enter product name'
                    className='mpf-input'
                  />
                </div>
                {/* Brand */}
                <div className='mpf-group'>
                  <label htmlFor='mpf-brand-input' className='mpf-label'>
                    <Tag size={18} className='mpf-icon' />
                    Brand
                  </label>
                  <input
                    maxLength={20}
                    value={productData.brand}
                    onChange={(e) => setProductData({ ...productData, brand: e.target.value })}
                    type='text'
                    id='mpf-brand-input'
                    name='brand'
                    placeholder='Enter brand name'
                    className='mpf-input'
                  />
                </div>
                {/*  <div className='inputCustdet'>
                  <input
                    maxLength={20}
                    value={productData.brand}
                    onChange={(e) => setProductData({ ...productData, brand: e.target.value })}
                    type={"text"}
                    required={true}
                  />
                  <p className='placeholderInputcusd'>Brand</p>
                </div> */}

                {/* Category */}
                <div className='mpf-group'>
                  <label htmlFor='mpf-category-select' className='mpf-label'>
                    <Grid3X3 size={18} className='mpf-icon' />
                    Category
                  </label>
                  <div className='mpf-select-wrapper'>
                    <select
                      value={productData.productCategory}
                      onChange={(e) => setProductData({ ...productData, productCategory: e.target.value })}
                      id='mpf-category-select'
                      name='category'
                      className='mpf-select'
                    >
                      <option value='' disabled selected hidden>
                        Choose category
                      </option>
                      {listOfProductCategory.map((category) => (
                        <option>{category}</option>
                      ))}
                      <option>Others</option>
                    </select>
                    <div className='mpf-select-arrow'>
                      <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                        <path d='M3 4.5L6 7.5L9 4.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </div>
                  </div>
                </div>

                {/*   <div className='inputCustdet DRAGUP'>
                  <select value={productData.productCategory} onChange={(e) => setProductData({ ...productData, productCategory: e.target.value })}>
                    <option value='' disabled selected hidden>
                      Choose category
                    </option>
                    {listOfProductCategory.map((category) => (
                      <option>{category}</option>
                    ))}
                    <option>Others</option>
                  </select>
                </div> */}
                {/* Product State */}
                <div className='mpf-group'>
                  <label htmlFor='mpf-state-select' className='mpf-label'>
                    <Info size={18} className='mpf-icon' />
                    Product state
                  </label>
                  <div className='mpf-select-wrapper'>
                    <select
                      value={productData.productState}
                      onChange={(e) => setProductData({ ...productData, productState: e.target.value })}
                      id='mpf-state-select'
                      name='productState'
                      className='mpf-select'
                    >
                      <option value='' disabled selected hidden>
                        Product state
                      </option>
                      <option>new</option>
                      <option>used like new</option>
                      <option>used</option>
                    </select>
                    <div className='mpf-select-arrow'>
                      <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                        <path d='M3 4.5L6 7.5L9 4.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </div>
                  </div>
                </div>
                {/*   <div className='inputCustdet DRAGUP'>
                  <select value={productData.productState} onChange={(e) => setProductData({ ...productData, productState: e.target.value })}>
                    <option value='' disabled selected hidden>
                      Product state
                    </option>
                    <option>new</option>
                    <option>used like new</option>
                    <option>used</option>
                  </select>
                </div> */}
                {/* Unit */}
                <div className='mpf-group'>
                  <label htmlFor='mpf-unit-select' className='mpf-label'>
                    <Ruler size={18} className='mpf-icon' />
                    Unit
                  </label>
                  <div className='mpf-select-wrapper'>
                    <select
                      value={productData.unit}
                      onChange={(e) => setProductData({ ...productData, unit: e.target.value })}
                      id='mpf-unit-select'
                      name='unit'
                      className='mpf-select'
                    >
                      <option value='' disabled selected hidden>
                        Select unit
                      </option>
                      {productUnit.map((unit) => (
                        <option>{unit}</option>
                      ))}
                      <option>Others</option>
                    </select>
                    <div className='mpf-select-arrow'>
                      <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                        <path d='M3 4.5L6 7.5L9 4.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className='pricing-section-main-zx913'>
              <div className='pricing-grid-layout-ab456'>
                {/* Quantity Field */}
                <div className='pricing-field-wrapper-cd789'>
                  <label className='pricing-field-label-ef012'>
                    <Hash className='pricing-label-icon-gh345' />
                    Quantity
                  </label>
                  <div className='pricing-input-container-ij678'>
                    <input
                      key={isMobileDevice ? "mobile" : "desktop"}
                      pattern={isMobileDevice ? "[0-9]*" : undefined}
                      type={isMobileDevice ? "text" : "number"}
                      inputMode='numeric' // shows numeric keyboard on mobile
                      onBeforeInput={isMobileDevice ? allowDigits : undefined}
                      placeholder='0'
                      className='pricing-input-field-kl901'
                      value={productData.quantity}
                      onKeyDown={(e) => {
                        if (unWantedInputs.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setProductData({ ...productData, quantity: e.target.value });
                      }}
                    />
                    <span className='pricing-input-suffix-mn234'>#</span>
                  </div>
                </div>

                {/* Cost Price Field */}
                <div className='pricing-field-wrapper-cd789'>
                  <label className='pricing-field-label-ef012'>
                    <DollarSign className='pricing-label-icon-gh345' />
                    Cost price
                  </label>
                  <div className='pricing-input-container-ij678'>
                    <input
                      key={isMobileDevice ? "mobile" : "desktop"}
                      pattern={isMobileDevice ? "[0-9]*" : undefined}
                      type={isMobileDevice ? "text" : "number"}
                      inputMode='numeric' // shows numeric keyboard on mobile
                      onBeforeInput={isMobileDevice ? allowDigits : undefined}
                      value={productData.costPrice}
                      onKeyDown={(e) => {
                        if (unWantedInputs.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => setProductData({ ...productData, costPrice: e.target.value })}
                      required={true}
                      placeholder='0.00'
                      className='pricing-input-field-kl901'
                      step='0.01'
                    />
                    <span className='pricing-input-suffix-mn234'>{user.userCountryCurrencySymbol}</span>
                  </div>
                </div>

                {/* Stock Limit Field */}
                <div className='pricing-field-wrapper-cd789'>
                  <label className='pricing-field-label-ef012'>
                    <Package className='pricing-label-icon-gh345' />
                    Stock limit
                  </label>
                  <div className='pricing-input-container-ij678'>
                    <input
                      key={isMobileDevice ? "mobile" : "desktop"}
                      pattern={isMobileDevice ? "[0-9]*" : undefined}
                      type={isMobileDevice ? "text" : "number"}
                      inputMode='numeric' // shows numeric keyboard on mobile
                      onBeforeInput={isMobileDevice ? allowDigits : undefined}
                      value={productData.stockLimit}
                      onKeyDown={(e) => {
                        if (unWantedInputs.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => setProductData({ ...productData, stockLimit: e.target.value })}
                      placeholder='0'
                      className={`pricing-input-field-kl901 ${!isStockLimitLessThanQuantity ? "pricing-input-error-op567" : ""}`}
                    />
                    <Package className='pricing-input-icon-qr890' />
                  </div>
                  {!isStockLimitLessThanQuantity && <span className='pricing-error-text-st123'>Stock limit cannot be higher than quantity</span>}
                </div>

                {/* Unit Price Field */}
                <div className='pricing-field-wrapper-cd789'>
                  <label className='pricing-field-label-ef012'>
                    <TrendingUp className='pricing-label-icon-gh345' />
                    Unit price
                  </label>
                  <div className='pricing-input-container-ij678'>
                    <input
                      key={isMobileDevice ? "mobile" : "desktop"}
                      pattern={isMobileDevice ? "[0-9]*" : undefined}
                      type={isMobileDevice ? "text" : "number"}
                      inputMode='numeric' // shows numeric keyboard on mobile
                      onBeforeInput={isMobileDevice ? allowDigits : undefined}
                      value={productData.unitPrice}
                      onKeyDown={(e) => {
                        if (unWantedInputs.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => setProductData({ ...productData, unitPrice: e.target.value })}
                      required={true}
                      placeholder='0.00'
                      className={`pricing-input-field-kl901 ${!isCostPricelessThanUnitPrice ? "pricing-input-warning-uv456" : ""}`}
                      step='0.01'
                    />
                    <span className='pricing-input-suffix-mn234'>{user.userCountryCurrencySymbol}</span>
                  </div>
                  {!isCostPricelessThanUnitPrice && <span className='pricing-warning-text-wx789'>Unit price should be higher than cost price for profit</span>}
                </div>
              </div>
            </div>

            <div className='hrline'></div>

            <div className='sizedescriptDeliv'>
              <div>
                <div className={size ? "sizedivdrwawer sizeTrue" : "sizedivdrwawer"}>
                  <div className='canbeDeliveredDIv'>
                    <div className='pricing-field-label-ef012'>
                      {" "}
                      <RulerDimensionLine size={16} color='#3B82F6' />
                      <p style={{ color: "#3B82F6", fontWeight: "700" }}> Is size applicable?</p>
                    </div>
                    <DeliverToggle key={1} toggleValue={size} updatetoggle={setSize} />
                  </div>
                  <div className='sizeContainer12'>{selectedSize && selectedSize.map((size) => <SizeTag size={size.code} />)}</div>
                  <div className='canbeDeliveredDIv'>
                    <div className='pricing-field-label-ef012'>
                      <Palette size={16} color='#3B82F6' />
                      <p style={{ color: "#3B82F6", fontWeight: "700" }}> Is color applicable?</p>
                    </div>
                    <DeliverToggle key={2} toggleValue={isColorApplicable} updatetoggle={setIsColorApplicable} />
                  </div>
                  <div className='sizeContainer12'>{selectedColor && selectedColor.map((color) => <ColorTag color={color.name} />)}</div>
                </div>
                <div>
                  <div className='canbeDeliveredDIv'>
                    <div className='pricing-field-label-ef012'>
                      <Globe size={16} color='#3B82F6' />
                      <p style={{ color: "#3B82F6", fontWeight: "700" }}> can item be purchased online?</p>
                    </div>
                    {/* <DeliverToggle key={3} toggleValue={canDeliver} updatetoggle={setCanDeliver} /> */}
                    <ProductDeliverToggle key={4} toggleValue={canDeliver} updatetoggle={setCanDeliver} removeDelivData={setProductData} />
                  </div>
                  <div className={canDeliver ? "deliveryDivSHake" : "deliveryDivSHake deShDHeigt"}>
                    <div>
                      <span>{user.userCountryCurrencySymbol}</span>
                      <input
                        key={isMobileDevice ? "mobile" : "desktop"}
                        pattern={isMobileDevice ? "[0-9]*" : undefined}
                        type={isMobileDevice ? "text" : "number"}
                        inputMode='numeric' // shows numeric keyboard on mobile
                        onBeforeInput={isMobileDevice ? allowDigits : undefined}
                        value={productData.deliveryFee}
                        onKeyDown={(e) => {
                          if (unWantedInputs.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => setProductData({ ...productData, deliveryFee: e.target.value })}
                        className='deliveryParainput'
                        placeholder='Delivery fee'
                      />
                    </div>
                    <span></span>
                    <div>
                      <input
                        key={isMobileDevice ? "mobile" : "desktop"}
                        pattern={isMobileDevice ? "[0-9]*" : undefined}
                        type={isMobileDevice ? "text" : "number"}
                        inputMode='numeric' // shows numeric keyboard on mobile
                        onBeforeInput={isMobileDevice ? allowDigits : undefined}
                        value={productData.deliveryTime}
                        onKeyDown={(e) => {
                          if (unWantedInputs.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => setProductData({ ...productData, deliveryTime: e.target.value > 4 ? 4 : e.target.value })}
                        max={4}
                        min={1}
                        className='deliveryParainput'
                        placeholder='Delivery time'
                      />
                      <span>days</span>
                    </div>
                  </div>
                </div>
                {!scannedID ? (
                  <button onClick={() => setOpenScanner()} className='scanBarCd22btn'>
                    <BsUpcScan size={20} />
                    Add barcode
                  </button>
                ) : (
                  <div style={{ width: "100%", position: "relative" }}>
                    {" "}
                    <svg className='barcodeSVG' ref={barcodeRef} />
                    <p
                      onClick={() => {
                        setScannedID(null);
                      }}
                      className=''
                    >
                      X
                    </p>
                  </div>
                )}
              </div>
              <div>
                {/*  <textarea
                  value={productData.productDescription}
                  onChange={(e) => setProductData({ ...productData, productDescription: e.target.value })}
                  className='productDescription'
                  name=''
                  id=''
                  cols='30'
                  rows='6'
                  maxLength={260}
                  placeholder={"Product description"}
                ></textarea> */}
                <ReactQuill
                  theme='snow'
                  value={productData.productDescription}
                  //onChange={(e) => setProductData({ ...productData, productDescription: e })}
                  onChange={(e) => handleTyping(e)}
                  className='productDescription'
                  modules={{
                    toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], , ["clean"]],
                  }}
                  placeholder={"Product description"}
                />
              </div>
            </div>
          </div>
        </div>
        {!isTyping && (
          <div className='createProdDivButton'>
            {isFormValid ? (
              <button onClick={createProduct} className='createProButton'>
                {" "}
                <FiPlus size={26} />
                Create product
              </button>
            ) : (
              <button onClick={createProduct} style={{ opacity: "0.6" }} className='createProButton'>
                {" "}
                <FiPlus size={26} />
                Create product
              </button>
            )}
          </div>
        )}
      </div>

      {openSizeModal && <Wishes closeModalWithSizeFalse={setSize} closeModalWithSizeTrue={setOpenSizeModal} updateSelectedSize={setSelectedSize} />}

      {openColorModal && (
        <WisheColor updateSelectedColor={setSelectedColor} closeModalWithColorTrue={setOpenColorModal} closeModalWithColorFalse={setIsColorApplicable} />
      )}
      {isLoading && <Spinner position={"fixed"} />}

      {takeImageWithPhone && (
        <UploadImageWithPhone
          setTakeImageWithPhone={setTakeImageWithPhone}
          store={store}
          socket={socket}
          setCroppedImageUrl={setProductImages}
          setCroppedImageBolb={setProductBuffer}
          setIsImageUploaded={setIsImageUploaded}
        />
      )}

      {isImageCropperOpen && (
        <ImageCropper
          readImageUrl={productImageStage}
          setCroppedImageUrl={setProductImages}
          setCroppedImageBolb={setProductBuffer}
          closeModal={setIsImageCropperOpen}
          borderRadius={4}
          isMultipleImage={true}
        />
      )}

      {openScannerWindow &&
        (isMobileDevice ? (
          <BarcodeScanner
            setScanCodeString={setScannedID}
            handleProductScan={() => {
              // do nothing
            }}
            setOpenScannerModal={setOpenScannerWindow}
            isCreatingProduct={true}
          />
        ) : (
          <ScannerWindow setOpenScannerWindow={setOpenScannerWindow} setScannedID={setScannedID} />
        ))}
    </>
  );
};

export default AddStockPage;

export const naira = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14.164' height='16.221' viewBox='0 0 14.164 16.221'>
    <g id='Group_2574' data-name='Group 2574' transform='translate(6693.847 -3688.594)'>
      <path
        id='Path_3539'
        data-name='Path 3539'
        d='M-6690.933,3703.362V3689.78'
        transform='translate(0 0)'
        fill='none'
        stroke='#707070'
        stroke-linecap='round'
        stroke-width='2'
      />
      <path
        id='Path_3542'
        data-name='Path 3542'
        d='M0,12.564V0'
        transform='translate(-6680.482 3697.362) rotate(90)'
        fill='none'
        stroke='#707070'
        stroke-linecap='round'
        stroke-width='1.6'
      />
      <path
        id='Path_3543'
        data-name='Path 3543'
        d='M0,12.564V0'
        transform='translate(-6680.483 3695.342) rotate(90)'
        fill='none'
        stroke='#707070'
        stroke-linecap='round'
        stroke-width='1.6'
      />
      <path
        id='Path_3541'
        data-name='Path 3541'
        d='M-6690.933,3703.362V3689.78'
        transform='translate(8.115 0.268)'
        fill='none'
        stroke='#707070'
        stroke-linecap='round'
        stroke-width='2'
      />
      <path
        id='Path_3540'
        data-name='Path 3540'
        d='M0,0,8.18,13.709'
        transform='translate(-6690.734 3689.78) rotate(1)'
        fill='none'
        stroke='#707070'
        stroke-linecap='round'
        stroke-width='1.7'
      />
    </g>
  </svg>
);

export const ScannerWindow = ({ setOpenScannerWindow, setScannedID }) => {
  const [scannerdID, setScannerID] = useState(null);

  const handleScannerInput = () => {
    if (scannerdID) {
      setScannedID(scannerdID);
      setOpenScannerWindow(false);
    } else {
      uiAlert("please enter a valid barcode", "warning");
    }
  };
  return (
    <>
      <div className='scannerWindow233'>
        <div className='ScannerInput4'>
          <input
            value={scannerdID}
            onChange={(e) => setScannerID(e.target.value)}
            autoFocus={true}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleScannerInput();
              }
            }}
            type={"text"}
            placeholder='Scan or enter barcode'
          />
          <button onClick={handleScannerInput}>Enter</button>
        </div>
        <button
          onClick={() => {
            setOpenScannerWindow(false);
          }}
        >
          close
        </button>
      </div>
    </>
  );
};
